export default __webpack_public_path__ + "static/media/bmm-slider-2.fa7178df.jpg";